import { Component, OnInit, ViewChild } from '@angular/core';
import { HistoryUploadDetailComponent } from '../../Core/Shared/HistoryUpload/HistoryUploadDetail.component';

@Component({
  selector: 'OtherHistoryUploadDetail',
  templateUrl: './OtherHistoryUploadDetail.component.html'
})
export class OtherHistoryUploadDetailComponent {
}
